import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PredictionsSection } from "@/components/PredictionsSection";
import { Footer } from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";

export default function PredictionsPage() {
  const { lang } = useLanguage();
  return (
    <div data-testid="predictions-page" className="relative">
      <PredictionsSection variant="page" />
      <div className="text-center pb-12">
        <Link
          to="/"
          data-testid="predictions-back-home"
          className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-[#d4af37] transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          {lang === "es" ? "Volver al inicio" : "Back home"}
        </Link>
      </div>
      <Footer />
    </div>
  );
}
